module.exports = __webpack_public_path__ + "static/media/estilo de gestión.176d5cdd.svg";